import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../api/apiService";
import { API_ENDPOINTS } from "../../../constants/apiEndpoints";

export const getUserProfileAction = createAsyncThunk(
  "userProfile/getProfile",
  async (uid, thunkAPI) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.USER_PROFILE.GET(uid)
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateUserProfileAction = createAsyncThunk(
  "userProfile/updateProfile",
  async (profileData, thunkAPI) => {
    try {
      const response = await apiService.put(
        API_ENDPOINTS.USER_PROFILE.UPDATE,
        profileData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const uploadAvatarAction = createAsyncThunk(
  "userProfile/uploadAvatar",
  async (formData, thunkAPI) => {
    try {
      const response = await apiService.request(
        API_ENDPOINTS.USER_PROFILE.UPLOAD_AVATAR,
        {
          method: "POST",
          body: formData,
          headers: {
            // Don't set Content-Type for FormData, let the browser set it
          },
        }
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
